document.addEventListener('DOMContentLoaded', function () {
  const radioButtons = document.querySelectorAll('input[name="paire_choice"]');
  const qtyInput = document.querySelector('#paire-adjusted-quantity');
  radioButtons.forEach(rb => {
    rb.addEventListener('change', function () {
      const priceElement = document.querySelector('.price-item'); // ajuste selon ton thème
      const originalPrice = parseFloat(priceElement?.dataset.originalPrice || priceElement?.innerText.replace(/[^\d\.]/g, '') || 0);
      const productImage = document.querySelector('.product__media img'); // ajuste selon ton thème
      const originalImage = productImage?.src;
      const paireImage = productImage?.dataset.paireImage; // à ajouter via un metafield si tu veux une image spécifique pour la paire
      if (this.value === 'Paire') {
        qtyInput.value = 2;
        if (priceElement) {
          priceElement.innerText = (originalPrice * 2).toFixed(0) + " €";
        }
        if (paireImage && productImage) {
          productImage.src = paireImage;
        }
      } else {
        qtyInput.value = 1;
        if (priceElement) {
          priceElement.innerText = (originalPrice / 2).toFixed(0) + " €";
        }
        if (productImage) {
          productImage.src = originalImage;
        }
      }
    });
  });
});